import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Testin'",
  "description": "",
  "published": "2007-01-04T00:00:00.000Z",
  "redirect_from": ["/blog/testin/swizec/339"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`uhm.. poke? O.o`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      